import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      {/* Decorative Background Elements */}
      <div className="bg-circle bg-circle-yellow"></div>
      <div className="bg-circle bg-circle-red"></div>

      <div className="footer-container">
        {/* About Section */}
        <div className="footer-col about">
          <h5>Sahaj Public School</h5>
          <p>
            Sahaj Public School is dedicated to holistic education, academic
            excellence, and fostering lifelong learning in a nurturing,
            innovative environment.
          </p>
        </div>

        {/* Help Section */}
        <div className="footer-col help">
          <h5>Need Help?</h5>
          <button className="btn-contact">
            <i className="fas fa-question-circle"></i> Contact Us
          </button>
        </div>

        {/* Contact Section */}
        <div className="footer-col contact">
          <h5>Contact Us</h5>
          <p><i className="fas fa-map-marker-alt"></i> Dupada Road, Shajapur, 465001</p>
          <p>
            <i className="fas fa-envelope"></i>{' '}
            <a href="mailto:sahajpublicschool1@gmail.com">sahajpublicschool1@gmail.com</a>
          </p>
          <p><i className="fas fa-phone"></i> 07364-299088</p>
          <p><i className="fas fa-mobile-alt"></i> 7000434300</p>

          {/* Social Media Links */}
          <div className="social-links">
            <a href="https://www.facebook.com/sahajpublicschool" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <img src={require('../asets/facebook-icon.jpg')} alt="Facebook" />
            </a>
            <a href="https://twitter.com/sahajpublicschool" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <img src={require('../asets/twitter-icon.jpg')} alt="Twitter" />
            </a>
            <a href="https://www.instagram.com/sahajpublicschool" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <img src={require('../asets/instagram-icon.png')} alt="Instagram" />
            </a>
            <a href="https://wa.me/7000434300" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
              <img src={require('../asets/whatapp-icon.jpg')} alt="WhatsApp" />
            </a>
            <a href="http://www.youtube.com/@sahajpublicschool" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <img src={require('../asets/youtube-icon.jpg')} alt="YouTube" />
            </a>
          </div>
        </div>
      </div>

      {/* Developer Credit */}
      <div className="developer-credit" role="contentinfo">
        <p>
          Developed by <strong>Skyware-X Technology</strong>
          
          | Contact: 9754080290
        </p>
      </div>
    </footer>
  );
};

export default Footer;
